import Events from '@utilities/events';

const IMAGE_ZOOM_HOOK = '[js-hook-image-zoom]';

const FULLSCREEN_CLASS = 'image-zoom--fullscreen';

class HighResImageGallery {
  constructor(element) {
    this.element = element;
    this.zoomImages = [...this.element.querySelectorAll(IMAGE_ZOOM_HOOK)];
    this.zoomImagesRegister = [];

    this.zoomImages.forEach(zoomImage => {
      this.zoomImagesRegister.push(zoomImage.id);
    })

    this.bindEvents();
  }

  bindEvents() {
    Events.$on('high-res-image-gallery::prev', (id) => this.navigateGallery(id, 'prev'));
    Events.$on('high-res-image-gallery::next', (id) => this.navigateGallery(id, 'next'));
  }

  navigateGallery(id, direction) {
    this.zoomImages.forEach(zoomImage => {
      zoomImage.classList.remove(FULLSCREEN_CLASS);
      Events.$trigger(`zoom-image::hide-highres-image-${zoomImage.id}`);

      if (zoomImage.id === this.zoomImagesRegister[this.getNextZoomIndex(this.zoomImagesRegister.indexOf(id.detail), direction)]) {
        zoomImage.classList.add(FULLSCREEN_CLASS);
        Events.$trigger(`zoom-image::show-highres-image-${zoomImage.id}`);
      }
    });
  }

  getNextZoomIndex(currentZoomIndex, direction) {
    let nextZoomIndex = direction === 'next' ? currentZoomIndex + 1 : currentZoomIndex - 1;

    if (nextZoomIndex > (this.zoomImagesRegister.length - 1)) {
      nextZoomIndex = 0;
    } else if (nextZoomIndex === -1) {
      nextZoomIndex = this.zoomImagesRegister.length - 1;
    }

    return nextZoomIndex;
  }
}

export default HighResImageGallery;
